function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOffline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.497,
    height: 54.543,
    viewBox: "0 0 64.497 54.543",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 10764"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 10761"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 10760",
    transform: "translate(-800.061 -643.045)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 198",
    transform: "translate(801.811 644.795)",
    style: {
      fill: "none",
      stroke: "#343953",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.5px"
    },
    d: "M60.997 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 1956",
    transform: "translate(807.265 644.795)",
    style: {
      fill: "none",
      stroke: "#343953",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.5px"
    },
    d: "M0 0h50.089v35.695H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 199",
    transform: "translate(832.309 680.613)",
    style: {
      fill: "none",
      stroke: "#343953",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.5px"
    },
    d: "M0 0v7.499"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 269",
    cx: 3.863,
    cy: 3.863,
    r: 3.863,
    transform: "translate(828.446 688.112)",
    style: {
      fill: "none",
      stroke: "#343953",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.5px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 10763"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 10762",
    transform: "translate(-800.061 -643.045)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 1957",
    width: 4.2,
    height: 20.453,
    rx: 1.423,
    transform: "translate(818.672 652.416)",
    style: {
      fill: "#91c2d8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 1958",
    width: 4.2,
    height: 12.244,
    rx: 1.423,
    transform: "translate(826.364 660.625)",
    style: {
      fill: "#91c2d8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 1959",
    width: 4.2,
    height: 19.992,
    rx: 1.423,
    transform: "translate(834.056 652.877)",
    style: {
      fill: "#91c2d8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 1960",
    width: 4.2,
    height: 12.007,
    rx: 1.423,
    transform: "translate(841.747 660.862)",
    style: {
      fill: "#91c2d8"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffline);
export default __webpack_public_path__ + "static/media/offline.0d486512.svg";
export { ForwardRef as ReactComponent };